import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TopNavigation from '../../components/base/TopNavigation';
import BottomNavigation from '../../components/base/BottomNavigation';

interface Message {
  id: number;
  sender: string;
  content: string;
  timestamp: string;
  isOwn: boolean;
}

export default function MessagesPage() {
  const { t } = useTranslation();
  const [messages, setMessages] = useState<Message[]>([
    {
      id: 1,
      sender: 'أحمد',
      content: 'مرحباً جميعاً! كيف حالكم اليوم؟',
      timestamp: '10:30',
      isOwn: false
    },
    {
      id: 2,
      sender: 'فاطمة',
      content: 'الحمد لله، نحن بخير. ماذا عن العشاء اليوم؟',
      timestamp: '10:32',
      isOwn: false
    },
    {
      id: 3,
      sender: 'أنت',
      content: 'سأحضر الطعام في طريق العودة من العمل',
      timestamp: '10:35',
      isOwn: true
    },
    {
      id: 4,
      sender: 'سارة',
      content: 'رائع! هل تحتاج مساعدة في شيء؟',
      timestamp: '10:40',
      isOwn: false
    }
  ]);
  
  const [newMessage, setNewMessage] = useState('');

  const handleSendMessage = () => {
    if (newMessage.trim()) {
      const message: Message = {
        id: messages.length + 1,
        sender: 'أنت',
        content: newMessage,
        timestamp: new Date().toLocaleTimeString('ar', { hour: '2-digit', minute: '2-digit' }),
        isOwn: true
      };
      setMessages([...messages, message]);
      setNewMessage('');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50">
      <TopNavigation title={t('familyChat')} />
      
      <div className="pt-16 pb-20 px-4">
        <div className="space-y-4">
          {messages.map((message) => (
            <div
              key={message.id}
              className={`flex ${message.isOwn ? 'justify-end' : 'justify-start'}`}
            >
              <div
                className={`max-w-xs lg:max-w-md px-4 py-3 rounded-2xl ${
                  message.isOwn
                    ? 'bg-[#5B9BD5] text-white rounded-br-md'
                    : 'bg-white text-gray-800 rounded-bl-md shadow-sm'
                }`}
              >
                {!message.isOwn && (
                  <p className="text-xs font-semibold text-[#5B9BD5] mb-1">
                    {message.sender}
                  </p>
                )}
                <p className="text-sm">{message.content}</p>
                <p className={`text-xs mt-1 ${message.isOwn ? 'text-blue-100' : 'text-gray-500'}`}>
                  {message.timestamp}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Message Input */}
      <div className="fixed bottom-16 left-0 right-0 bg-white border-t border-gray-100 p-4">
        <div className="flex items-center space-x-3 space-x-reverse">
          <button
            onClick={handleSendMessage}
            className="w-10 h-10 bg-[#5B9BD5] rounded-full flex items-center justify-center"
          >
            <i className="ri-send-plane-fill text-white text-lg"></i>
          </button>
          <input
            type="text"
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
            placeholder={t('typeMessage')}
            className="flex-1 px-4 py-3 bg-gray-100 rounded-full border-none focus:outline-none focus:ring-2 focus:ring-[#5B9BD5]/20 text-sm"
          />
          <button className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center">
            <i className="ri-attachment-2 text-gray-600 text-lg"></i>
          </button>
        </div>
      </div>

      <BottomNavigation />
    </div>
  );
}
